import { cloneElement, isValidElement, ReactElement } from 'react';

interface Props {
  icon: any;
}

const Circle = (props: Props): ReactElement => {
  const { icon } = props;

  const className =
    isValidElement(icon) && icon.type === 'span'
      ? 'opds-styles-v1-text-title-large'
      : 'investoracademy-timespan-icon';
  const iconWithClassName = cloneElement(icon, {
    className,
  });
  return <div className="investoracademy-circle">{iconWithClassName}</div>;
};

export default Circle;
